import fetchIntercept from 'fetch-intercept';
import loginService from '../service/login';

fetchIntercept.register({
  request: function(url, config) {
    // Modify the url or config here
    return [url, config];
  },

  requestError: function(error) {
    // Called when an error occured during another 'request' interceptor call
    return Promise.reject(error);
  },

  response: function(response) {
    // Modify the reponse object
    const myHeaders = new Headers(response.headers);
    const token = myHeaders.get('Token');
    if (token) {
      loginService.updateToken(token);
    }

    return response;
  },

  responseError: function(error) {
    // Handle an fetch error
    return Promise.reject(error);
  },
});
